import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

import { RunOnceScheduler, createCancelablePromise } from '../../../base/common/async.js';
import { Disposable } from '../../../base/common/lifecycle.js';
import { registerEditorContribution } from '../../browser/editorExtensions.js';
import { DocumentRangeSemanticTokensProviderRegistry } from '../../common/modes.js';
import { IModelService } from '../../common/services/modelService.js';
import { toMultilineTokens2 } from '../../common/services/semanticTokensProviderStyling.js';
import { IThemeService } from '../../../platform/theme/common/themeService.js';
import { IConfigurationService } from '../../../platform/configuration/common/configuration.js';
import { isSemanticColoringEnabled, SEMANTIC_HIGHLIGHTING_SETTING_ID } from '../../common/services/modelServiceImpl.js';

var ViewportSemanticTokensContribution = /*#__PURE__*/function (_Disposable) {
  _inherits(ViewportSemanticTokensContribution, _Disposable);

  var _super = _createSuper(ViewportSemanticTokensContribution);

  function ViewportSemanticTokensContribution(editor, _modelService, _themeService, _configurationService) {
    var _this;

    _classCallCheck(this, ViewportSemanticTokensContribution);

    _this = _super.call(this);
    _this._modelService = _modelService;
    _this._themeService = _themeService;
    _this._configurationService = _configurationService;
    _this._editor = editor;
    _this._tokenizeViewport = new RunOnceScheduler(function () {
      return _this._tokenizeViewportNow();
    }, 100);
    _this._outstandingRequests = [];

    _this._register(_this._editor.onDidScrollChange(function () {
      _this._tokenizeViewport.schedule();
    }));

    _this._register(_this._editor.onDidChangeModel(function () {
      _this._cancelAll();

      _this._tokenizeViewport.schedule();
    }));

    _this._register(_this._editor.onDidChangeModelContent(function (e) {
      _this._cancelAll();

      _this._tokenizeViewport.schedule();
    }));

    _this._register(DocumentRangeSemanticTokensProviderRegistry.onDidChange(function () {
      _this._cancelAll();

      _this._tokenizeViewport.schedule();
    }));

    _this._register(_this._configurationService.onDidChangeConfiguration(function (e) {
      if (e.affectsConfiguration(SEMANTIC_HIGHLIGHTING_SETTING_ID)) {
        _this._cancelAll();

        _this._tokenizeViewport.schedule();
      }
    }));

    _this._register(_this._themeService.onDidColorThemeChange(function () {
      _this._cancelAll();

      _this._tokenizeViewport.schedule();
    }));

    return _this;
  }

  _createClass(ViewportSemanticTokensContribution, [{
    key: "_cancelAll",
    value: function _cancelAll() {
      var _iterator = _createForOfIteratorHelper(this._outstandingRequests),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var request = _step.value;
          request.cancel();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this._outstandingRequests = [];
    }
  }, {
    key: "_removeOutstandingRequest",
    value: function _removeOutstandingRequest(req) {
      for (var i = 0, len = this._outstandingRequests.length; i < len; i++) {
        if (this._outstandingRequests[i] === req) {
          this._outstandingRequests.splice(i, 1);

          return;
        }
      }
    }
  }, {
    key: "_tokenizeViewportNow",
    value: function _tokenizeViewportNow() {
      var _this2 = this;

      if (!this._editor.hasModel()) {
        return;
      }

      var model = this._editor.getModel();

      if (model.hasSemanticTokens()) {
        return;
      }

      if (!isSemanticColoringEnabled(model, this._themeService, this._configurationService)) {
        return;
      }

      var provider = ViewportSemanticTokensContribution._getSemanticColoringProvider(model);

      if (!provider) {
        return;
      }

      var styling = this._modelService.getSemanticTokensProviderStyling(provider);

      var visibleRanges = this._editor.getVisibleRangesPlusViewportAboveBelow();

      this._outstandingRequests = this._outstandingRequests.concat(visibleRanges.map(function (range) {
        return _this2._requestRange(model, range, provider, styling);
      }));
    }
  }, {
    key: "_requestRange",
    value: function _requestRange(model, range, provider, styling) {
      var _this3 = this;

      var requestVersionId = model.getVersionId();
      var request = createCancelablePromise(function (token) {
        return Promise.resolve(provider.provideDocumentRangeSemanticTokens(model, range, token));
      });
      request.then(function (r) {
        if (!r || model.isDisposed() || model.getVersionId() !== requestVersionId) {
          return;
        }

        model.setPartialSemanticTokens(range, toMultilineTokens2(r, styling, model.getLanguageIdentifier()));
      }).then(function () {
        return _this3._removeOutstandingRequest(request);
      }, function () {
        return _this3._removeOutstandingRequest(request);
      });
      return request;
    }
  }], [{
    key: "_getSemanticColoringProvider",
    value: function _getSemanticColoringProvider(model) {
      var result = DocumentRangeSemanticTokensProviderRegistry.ordered(model);
      return result.length > 0 ? result[0] : null;
    }
  }]);

  return ViewportSemanticTokensContribution;
}(Disposable);

ViewportSemanticTokensContribution.ID = 'editor.contrib.viewportSemanticTokens';
ViewportSemanticTokensContribution = __decorate([__param(1, IModelService), __param(2, IThemeService), __param(3, IConfigurationService)], ViewportSemanticTokensContribution);
registerEditorContribution(ViewportSemanticTokensContribution.ID, ViewportSemanticTokensContribution);